import { apiClient } from './apiClient';

const getAdminReviews = async (data) => {
  return await apiClient.get('/dashboard/reviews', data);
};

const getAdminEditReview = async (id, data) => {
  return await apiClient.get(`/dashboard/reviews/edit/${id}`, data);
};

const updateAdminReview = async (id, data) => {
  return await apiClient.post_form(`/dashboard/reviews/${id}`, data);
};

export const adminReviewsApi = {
  getAdminReviews,
  getAdminEditReview,
  updateAdminReview,
};
